// import React, { useEffect, useState } from 'react';
// import { Base_Url } from '../config';
// import axios from 'axios';

// const AtAGlimpse = () => {
//   const [head, setHead] = useState([]);
//   const [srSysManager, setSrSysManager] = useState([]);
//   const [sysManager, setSystemManager] = useState([]);
//   const [sysArchitect, setSysArchitect] = useState([]);
//   const [staff, setStaff] = useState([]);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(`${Base_Url}/profiles`);
//       const data = response.data;

//       // Filter active staff to be displayed
//       const filteredData = data.filter(person => 
//         person.show_in_display === 1 && person.isretired === 0
//       );

//       // 1. First identify Head person
//       const headPerson = filteredData.filter(person => person.show_hod === 1);
//       setHead(headPerson);

//       // 2. Get IDs of Head persons to exclude from other sections
//       const headIds = headPerson.map(person => person.id);

//       // 3. Process other sections independently
      
//       // Sr. System Managers (excluding Heads)
//       const srSysManagers = filteredData
//         .filter(person => 
//           person.designation === 'Sr. System Manager (SG)' && 
//           !headIds.includes(person.id)
//         )
//         // Remove duplicates within this section
//         .filter((person, index, self) =>
//           index === self.findIndex(p => p.name === person.name)
//         );
//       setSrSysManager(srSysManagers);

//       // System Managers (excluding Heads)
//       const systemManagers = filteredData
//         .filter(person => 
//           person.designation === 'System Manager' && 
//           !headIds.includes(person.id)
//         )
//         .filter((person, index, self) =>
//           index === self.findIndex(p => p.name === person.name)
//         );
//       setSystemManager(systemManagers);

//       // System Architects (excluding Heads)
//       const sysArchitects = filteredData
//         .filter(person => 
//           person.designation === 'System Architect' && 
//           !headIds.includes(person.id)
//         )
//         .filter((person, index, self) =>
//           index === self.findIndex(p => p.name === person.name)
//         );
//       setSysArchitect(sysArchitects);

//       // Other Staff (excluding Heads and already categorized)
//       const otherStaff = filteredData
//         .filter(person => 
//           !['System Manager', 'Sr. System Manager (SG)', 'System Architect'].includes(person.designation) &&
//           !headIds.includes(person.id)
//         )
//         .filter((person, index, self) =>
//           index === self.findIndex(p => p.name === person.name)
//         );
//       setStaff(otherStaff);

//     } catch (error) {
//       console.error('Error fetching data:', error);
//     }
//   };

//   // Format names with separators
//   const formatNames = (peopleArray) => {
//     return peopleArray.map((person, index) => (
//       <React.Fragment key={person.id || index}>
//         <span className="staff-name">{person.name}</span>
//         {index < peopleArray.length - 1 && <span className="separator"> | </span>}
//       </React.Fragment>
//     ));
//   };

//   // Prepare table data
//   const tableData = [
//     ...(head.length > 0 ? [{ designation: 'Head', data: head }] : []),
//     ...(srSysManager.length > 0 ? [{ designation: 'Sr. System Manager (SG)', data: srSysManager }] : []),
//     ...(sysManager.length > 0 ? [{ designation: 'System Manager', data: sysManager }] : []),
//     ...(sysArchitect.length > 0 ? [{ designation: 'System Architect', data: sysArchitect }] : []),
//     ...(staff.length > 0 ? [{ designation: 'Technical & Non-Technical Staff', data: staff }] : [])
//   ];

//   return (
//     <div className="at-a-glimpse-container">
//       <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0">
//         AT A <span className="highlight-title">GLIMPSE</span>
//       </h2>
//       <hr />
      
//       <div className="at-a-glimpse-table-container">
//         <table className="at-a-glimpse-table">
//           <thead>
//             <tr className="at-a-glimpse-table-header">
//               <th style={{background:"#c21717", color:"#fff"}}>Designation</th>
//               <th style={{background:"#c21717", color:"#fff"}}>Name</th>
//             </tr>
//           </thead>
//           <tbody>
//             {tableData.map((row, index) => (
//               <tr key={index}>
//                 <td className="designation-cell fw-bold" style={{color:"#000"}}>
//                   {row.designation}
//                 </td>
//                 <td className="name-cell fw-semibold" style={{color:"#c21717"}}>
//                   <div className="names-wrapper">
//                     {formatNames(row.data)}
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <style jsx>{`
//         .at-a-glimpse-container {
//           width: 100%;
//           max-width: 1400px;
//           margin: 0 auto;
//           font-family: 'Roboto', sans-serif;
//           padding: 50px 5px !important;
//         }
        
//         .page-title {
//           margin-bottom: 1.5rem;
//         }
        
//         .highlight-title {
//           color: #c21717;
//         }
        
//         .at-a-glimpse-table-container {
//           overflow-x: auto;
//           margin-top: 20px;
//           box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//           border-radius: 8px;
//         }
        
//         .at-a-glimpse-table {
//           width: 100%;
//           border-collapse: collapse;
//           border: 1px solid #dee2e6;
//           font-size: 0.95rem;
//         }
        
//         .at-a-glimpse-table th,
//         .at-a-glimpse-table td {
//           padding: 0.75rem .52rem;
//           border: 1px solid #dee2e6;
//           transition: background-color 0.3s;
//         }
        
//         .at-a-glimpse-table th {
//           font-weight: 600;
//           text-align: left;
//         }
        
//         .at-a-glimpse-table td {
//           background-color: #fff;
//           color: #333;
//           text-align:left
//         }
        
//         .designation-cell {
//           width: 30%;
//           min-width: 150px;
//           vertical-align: top;
//         }
        
//         .name-cell {
//           width: 70%;
//         }
        
//         .names-wrapper {
//           display: flex;
//           flex-wrap: wrap;
//           align-items: center;
//           gap: 0;
//         }
        
//         .staff-name {
//           font-weight: 600;
//           white-space: nowrap;
//         }
        
//         .separator {
//           padding: 0 4px;
//           color: #888;
//         }
        
//         .at-a-glimpse-table tr:nth-child(even) td {
//           background-color: #f8f9fa;
//         }
        
//         @media (max-width: 1400px) {
//           .at-a-glimpse-container {
//             padding: 30px 15px;
//           }
//         }
        
//         @media (max-width: 992px) {
//           .at-a-glimpse-container {
//             padding: 25px 10px;
//           }
          
//           .at-a-glimpse-table th,
//           .at-a-glimpse-table td {
//             padding: 0.6rem 0.8rem;
//           }
//         }
        
//         @media (max-width: 768px) {
//           .at-a-glimpse-container {
//             padding: 20px 10px;
//           }
          
//           .at-a-glimpse-table {
//             font-size: 0.9rem;
//           }
          
//           .designation-cell {
//             white-space: normal;
//             word-break: break-word;
//           }
//         }
        
//         @media (max-width: 576px) {
//           .at-a-glimpse-container {
//             padding: 15px 5px;
//           }
          
//           .at-a-glimpse-table {
//             font-size: 0.85rem;
//           }
          
//           .at-a-glimpse-table th,
//           .at-a-glimpse-table td {
//             padding: 0.5rem;
//             display: block;
//             width: 100%;
//           }
          
//           .designation-cell {
//             border-bottom: none;
//             padding-bottom: 0;
//           }
          
//           .name-cell {
//             padding-top: 0;
//             border-top: none;
//           }
          
//           .names-wrapper {
//             display: block;
//           }
          
//           .staff-name {
//             display: inline;
//             white-space: normal;
//           }
          
//           .staff-name:after {
//             content: " | ";
//             color: #888;
//           }
          
//           .staff-name:last-child:after {
//             content: "";
//           }
          
//           .separator {
//             display: none;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default AtAGlimpse;

import React, { useEffect, useState } from 'react';
import { Base_Url } from '../config';
import axios from 'axios';

const AtAGlimpse = () => {
  const [head, setHead] = useState([]);
  const [srSysManager, setSrSysManager] = useState([]);
  const [sysManager, setSystemManager] = useState([]);
  const [sysArchitect, setSysArchitect] = useState([]);
  const [technicalStaff, setTechnicalStaff] = useState([]);
  const [nonTechnicalStaff, setNonTechnicalStaff] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${Base_Url}/profiles`);
      const data = response.data;

      // Filter active staff to be displayed
      const filteredData = data.filter(person => 
        person.show_in_display === 1 && person.isretired === 0
      );

      // 1. First identify Head person
      const headPerson = filteredData.filter(person => person.show_hod === 1);
      setHead(headPerson);

      // 2. Get IDs of Head persons to exclude from other sections
      const headIds = headPerson.map(person => person.id);

      // 3. Process other sections independently
      
      // Sr. System Managers (excluding Heads)
      const srSysManagers = filteredData
        .filter(person => 
          person.designation === 'Sr. System Manager (SG)' && 
          !headIds.includes(person.id)
        )
        // Remove duplicates within this section
        .filter((person, index, self) =>
          index === self.findIndex(p => p.name === person.name)
        );
      setSrSysManager(srSysManagers);

      // System Managers (excluding Heads)
      const systemManagers = filteredData
        .filter(person => 
          person.designation === 'System Manager' && 
          !headIds.includes(person.id)
        )
        .filter((person, index, self) =>
          index === self.findIndex(p => p.name === person.name)
        );
      setSystemManager(systemManagers);

      // System Architects (excluding Heads)
      const sysArchitects = filteredData
        .filter(person => 
          person.designation === 'System Architect' && 
          !headIds.includes(person.id)
        )
        .filter((person, index, self) =>
          index === self.findIndex(p => p.name === person.name)
        );
      setSysArchitect(sysArchitects);

      // Other Staff (excluding Heads and already categorized)
      const otherStaff = filteredData
        .filter(person => 
          !['System Manager', 'Sr. System Manager (SG)', 'System Architect'].includes(person.designation) &&
          !headIds.includes(person.id)
        )
        .filter((person, index, self) =>
          index === self.findIndex(p => p.name === person.name)
        );

      // SEPARATE TECHNICAL AND NON-TECHNICAL STAFF
      const technicalStaff = otherStaff.filter(person => 
        (person.technicalstaff === true || person.technicalstaff === 1) 
      );
      
      const nonTechnicalStaff = otherStaff.filter(person => 
        (person.technicalstaff === false || person.technicalstaff === 0) &&
        (person.ird === false || person.ird === 0)
      );

      setTechnicalStaff(technicalStaff);
      setNonTechnicalStaff(nonTechnicalStaff);

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Format names with separators
  const formatNames = (peopleArray) => {
    return peopleArray.map((person, index) => (
      <React.Fragment key={person.id || index}>
        <span className="staff-name">{person.name}</span>
        {index < peopleArray.length - 1 && <span className="separator"> | </span>}
      </React.Fragment>
    ));
  };

  // Prepare table data
  const tableData = [
    ...(head.length > 0 ? [{ designation: 'Head', data: head }] : []),
    ...(srSysManager.length > 0 ? [{ designation: 'Sr. System Manager (SG)', data: srSysManager }] : []),
    ...(sysManager.length > 0 ? [{ designation: 'System Manager', data: sysManager }] : []),
    ...(sysArchitect.length > 0 ? [{ designation: 'System Architect', data: sysArchitect }] : []),
    ...(technicalStaff.length > 0 ? [{ designation: 'Technical Staff', data: technicalStaff }] : []),
    ...(nonTechnicalStaff.length > 0 ? [{ designation: 'Non-Technical Staff', data: nonTechnicalStaff }] : [])
  ];

  return (
    <div className="at-a-glimpse-container">
      <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0">
        AT A <span className="highlight-title">GLIMPSE</span>
      </h2>
      <hr />
      
      <div className="at-a-glimpse-table-container">
        <table className="at-a-glimpse-table">
          <thead>
            <tr className="at-a-glimpse-table-header">
              <th style={{background:"#c21717", color:"#fff"}}>Designation</th>
              <th style={{background:"#c21717", color:"#fff"}}>Name</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={index}>
                <td className="designation-cell fw-bold" style={{color:"#000"}}>
                  {row.designation}
                </td>
                <td className="name-cell fw-semibold" style={{color:"#c21717"}}>
                  <div className="names-wrapper">
                    {formatNames(row.data)}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <style jsx>{`
        .at-a-glimpse-container {
          width: 100%;
          max-width: 1400px;
          margin: 0 auto;
          font-family: 'Roboto', sans-serif;
          padding: 50px 5px !important;
        }
        
        .page-title {
          margin-bottom: 1.5rem;
        }
        
        .highlight-title {
          color: #c21717;
        }
        
        .at-a-glimpse-table-container {
          overflow-x: auto;
          margin-top: 20px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
        }
        
        .at-a-glimpse-table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #dee2e6;
          font-size: 0.95rem;
        }
        
        .at-a-glimpse-table th,
        .at-a-glimpse-table td {
          padding: 0.75rem .52rem;
          border: 1px solid #dee2e6;
          transition: background-color 0.3s;
        }
        
        .at-a-glimpse-table th {
          font-weight: 600;
          text-align: left;
        }
        
        .at-a-glimpse-table td {
          background-color: #fff;
          color: #333;
          text-align:left
        }
        
        .designation-cell {
          width: 30%;
          min-width: 150px;
          vertical-align: top;
        }
        
        .name-cell {
          width: 70%;
        }
        
        .names-wrapper {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 0;
        }
        
        .staff-name {
          font-weight: 600;
          white-space: nowrap;
        }
        
        .separator {
          padding: 0 4px;
          color: #888;
        }
        
        .at-a-glimpse-table tr:nth-child(even) td {
          background-color: #f8f9fa;
        }
        
        @media (max-width: 1400px) {
          .at-a-glimpse-container {
            padding: 30px 15px;
          }
        }
        
        @media (max-width: 992px) {
          .at-a-glimpse-container {
            padding: 25px 10px;
          }
          
          .at-a-glimpse-table th,
          .at-a-glimpse-table td {
            padding: 0.6rem 0.8rem;
          }
        }
        
        @media (max-width: 768px) {
          .at-a-glimpse-container {
            padding: 20px 10px;
          }
          
          .at-a-glimpse-table {
            font-size: 0.9rem;
          }
          
          .designation-cell {
            white-space: normal;
            word-break: break-word;
          }
        }
        
        @media (max-width: 576px) {
          .at-a-glimpse-container {
            padding: 15px 5px;
          }
          
          .at-a-glimpse-table {
            font-size: 0.85rem;
          }
          
          .at-a-glimpse-table th,
          .at-a-glimpse-table td {
            padding: 0.5rem;
            display: block;
            width: 100%;
          }
          
          .designation-cell {
            border-bottom: none;
            padding-bottom: 0;
          }
          
          .name-cell {
            padding-top: 0;
            border-top: none;
          }
          
          .names-wrapper {
            display: block;
          }
          
          .staff-name {
            display: inline;
            white-space: normal;
          }
          
          .staff-name:after {
            content: " | ";
            color: #888;
          }
          
          .staff-name:last-child:after {
            content: "";
          }
          
          .separator {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default AtAGlimpse;